import { render, staticRenderFns } from "./createCustomer.vue?vue&type=template&id=66e0ad5b&scoped=true"
import script from "./createCustomer.vue?vue&type=script&lang=js"
export * from "./createCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e0ad5b",
  null
  
)

export default component.exports